"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-6ab43166"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon marso-icon-wheel" }, null, -1));
const _hoisted_2 = {
    key: 0,
    class: "text-bold"
};
const _hoisted_3 = { class: "font-bold" };
const _hoisted_4 = {
    key: 1,
    class: "grid gap-y-8 gap-x-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-5 w-full"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = { class: "text-sm" };
const _hoisted_7 = {
    key: 0,
    class: "border-b-1 border-gray"
};
const _hoisted_8 = { class: "px-2 py-1 inline-block text-left" };
const _hoisted_9 = { class: "float-right px-2 py-1 inline-block text-right font-bold" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("li", null, null, -1));
const _hoisted_11 = {
    key: 0,
    class: "md:col-span-2 lg:col-span-5"
};
const _hoisted_12 = { class: "uppercase text-xl md:text-3xl font-light" };
const _hoisted_13 = { class: "overflow-x-auto" };
const _hoisted_14 = { class: "load-capacity-table" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("th", null, " ", -1));
const _hoisted_16 = { class: "unit" };
const _hoisted_17 = { class: "unit" };
const _hoisted_18 = { class: "text-right" };
const _hoisted_19 = {
    key: 1,
    class: "md:col-span-2 lg:col-span-5"
};
const _hoisted_20 = { class: "uppercase text-xl md:text-3xl mb-4 font-light" };
const _hoisted_21 = ["innerHTML"];
const _hoisted_22 = {
    key: 2,
    class: "md:col-span-2 lg:col-span-5"
};
const _hoisted_23 = { class: "uppercase text-xl md:text-3xl mb-4 font-light" };
const _hoisted_24 = ["innerHTML"];
const _hoisted_25 = {
    key: 3,
    class: "md:col-span-2 lg:col-span-5"
};
const _hoisted_26 = { class: "uppercase text-xl md:text-3xl mb-4 font-light" };
const _hoisted_27 = ["innerHTML"];
const vue_3 = require("vue");
const Modal_vue_1 = __importDefault(require("./Modal.vue"));
const i18n_1 = require("../common/i18n");
const lodash_1 = require("lodash");
const cartsStore_1 = require("../stores/carts/cartsStore");
const vue_router_1 = require("vue-router");
const productPopupStore_1 = require("../stores/productPopup/productPopupStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ProductPopup',
    setup(__props) {
        const cartsStore = (0, cartsStore_1.useCartsStore)();
        const productPopupStore = (0, productPopupStore_1.useProductPopupStore)();
        const router = (0, vue_router_1.useRouter)();
        const modalIsOpen = (0, vue_3.computed)(() => productPopupStore.modalIsOpen);
        const modalIsLoading = (0, vue_3.computed)(() => productPopupStore.modalIsLoading);
        const isNotFound = (0, vue_3.computed)(() => productPopupStore.isNotFound);
        const product = (0, vue_3.computed)(() => productPopupStore.productInfo);
        const productSku = (0, vue_3.computed)(() => productPopupStore.productSku);
        const productData = (0, vue_3.computed)(() => productPopupStore.productData);
        const closeModal = () => productPopupStore.close();
        const readSpeeds = (loadCapacityTable) => {
            let speeds = [];
            let pressures = Object.keys(loadCapacityTable);
            if (pressures.length) {
                speeds = Object.keys(loadCapacityTable[pressures[0]]);
            }
            return speeds;
        };
        const displayProperties = (type) => {
            let typeProps = {};
            let props = {
                sku: "SKU",
                manufacturerName: "Manufacturer",
                // manufacturerDescription: 'Manufacturer description',
            };
            if ([
                "agricultural_tyre",
                "car_tyre",
                "truck_tyre",
                "motorcycle_tyre",
                "industrial_tyre",
            ].includes(type)) {
                let tyreProps = {
                    treadName: "Tread",
                    // treadDescription: 'Tread description',
                    size: "Size",
                    // width: 'Width',
                    // profile: 'Profile',
                    structure: "Structure",
                    // diameter: 'Diameter',
                    loadIndex: "Load index",
                    speedIndex: "Speed index",
                };
                switch (type) {
                    case "agricultural_tyre":
                        typeProps = {
                            ...tyreProps,
                            tlttNotation: "TLTT notation",
                            rimWidth: "Rim width",
                            allowedRim: "Allowed rim",
                            profileWidthMm: "Profile width mm",
                            outerDiameterMm: "Outer Diameter mm",
                            staticLoadedRadiusMm: "Static loaded radius mm",
                            rollingCircumference: "Rolling circumference",
                            tyrePressureBar: "Tyre pressure bar",
                            treadDepthMm: "Tread depth mm",
                            loadCapacityKgV1: "Load capacity kg v1",
                            loadCapacityKgV2: "Load capacity kg v2",
                        };
                        break;
                    case "car_tyre":
                        typeProps = {
                            ...tyreProps,
                            carType: "Car type",
                            season: "Season",
                            suv: "SUV",
                            fuelEfficiency: "Fuel efficiency",
                            wetGripClass: "Wet grip class",
                            noiseMeasurementClass: "Noise measurement class",
                            noiseMeasurementValue: "Noise measurement value",
                            runFlat: "Run flat",
                            runFlatNotation: "Run flat notation",
                            reinforcedVersion: "Reinforced version",
                            reinforcedVersionNotation: "Reinforced version notation",
                            rimFringeProtector: "Rim fringe protector",
                            rimFringeProtectorNotation: "Rim fringe protector notation",
                            homologatedNotation: "Homologated notation",
                            mudAndSnowNotation: "M&S notation",
                            treadDepthMm: "Tread depth mm",
                        };
                        break;
                    case "truck_tyre":
                        typeProps = {
                            ...tyreProps,
                            tyreType: "Tyre type",
                            applicationNotation: "Application notation",
                            fuelEfficiency: "Fuel efficiency",
                            wetGripClass: "Wet grip class",
                            noiseMeasurementClass: "Noise measurement class",
                            noiseMeasurementValue: "Noise measurement value",
                            reinforcedVersion: "Reinforced version",
                            reinforcedVersionNotation: "Reinforced version notation",
                            mudAndSnowNotation: "M&S notation",
                            tlttNotation: "TLTT notation",
                            treadDepthMm: "Tread depth mm",
                        };
                        break;
                    case "motorcycle_tyre":
                        // no extra attribute
                        typeProps = { ...tyreProps };
                        break;
                    case "industrial_tyre":
                        typeProps = {
                            ...tyreProps,
                            machineType: "Machine",
                            tlttNotation: "TLTT notation",
                            rimWidth: "Rim width",
                            allowedRim: "Allowed rim",
                            profileWidthMm: "Profile width mm",
                            outerDiameterMm: "Outer Diameter mm",
                            staticLoadedRadiusMm: "Static loaded radius mm",
                            rollingCircumference: "Rolling circumference",
                            tyrePressureBar: "Tyre pressure bar",
                            treadDepthMm: "Tread depth mm",
                            loadCapacityKgV1: "Load capacity kg v1",
                            loadCapacityKgV2: "Load capacity kg v2",
                        };
                        break;
                    default:
                        break;
                }
            }
            if ("rim" === type) {
                typeProps = {
                    size: "Size",
                    material: "Material",
                    width: "Width",
                    diameter: "Diameter",
                    holes: "Holes",
                    boltPattern: "Bolt pattern",
                    centerBore: "Center bore",
                    wheelOffset: "Wheel offset",
                    designName: "Design",
                    // desingDescription: 'Design description',
                };
            }
            if ("tube" === type) {
                typeProps = {
                    tubeType: "Tube type",
                    width: "Width",
                    diameter: "Diameter",
                    valveType: "Valve type",
                };
            }
            if ("hubcap" === type) {
                typeProps = {
                    diameter: "Diameter",
                };
            }
            return { ...props, ...typeProps };
        };
        const getPropertyValue = (type, key, value) => {
            var _a;
            const translatebleProperties = {
                agricultural_tyre: [],
                car_tyre: [],
                truck_tyre: [],
                motorcycle_tyre: [],
                industrial_tyre: [],
                rim: [],
                tube: [],
                hubcap: [],
            };
            if ((typeof translatebleProperties[type] !== "undefined" &&
                translatebleProperties[type].includes(key)) ||
                value === "true" ||
                value === "false") {
                return ((_a = (0, i18n_1.trans)((0, lodash_1.snakeCase)(`${type}_${key}_${value}_value`), value, "product_popup")) !== null && _a !== void 0 ? _a : value);
            }
            return value;
        };
        const addToCart = (event, sku) => {
            var _a;
            let target = event.target;
            if (!(target instanceof HTMLElement)) {
                return;
            }
            let input = (_a = target.parentNode) === null || _a === void 0 ? void 0 : _a.querySelector(".popup-quantity");
            let quantity = 0;
            if (input instanceof HTMLInputElement) {
                quantity = parseInt(input.value ? input.value : "0");
            }
            cartsStore
                .addProduct(router, quantity, sku !== null && sku !== void 0 ? sku : "")
                .then(() => {
                if (input instanceof HTMLInputElement) {
                    input.value = "";
                }
            });
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.unref)(product) !== null && (0, vue_2.unref)(productData) !== null)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                    key: 0,
                    closeable: true,
                    isOpen: (0, vue_2.unref)(modalIsOpen),
                    isLoading: (0, vue_2.unref)(modalIsLoading),
                    title: (0, vue_2.unref)(product).name !== null
                        ? (0, vue_2.unref)(product).name
                        : (0, vue_2.unref)(i18n_1.trans)('error_product_name_not_found', 'Error, product name not found!', 'product_popup'),
                    widthClasses: "w-full max-w-screen-lg",
                    onClose: _cache[0] || (_cache[0] = ($event) => (closeModal()))
                }, {
                    loading: (0, vue_2.withCtx)(() => [
                        _hoisted_1
                    ]),
                    default: (0, vue_2.withCtx)(() => {
                        var _a;
                        return [
                            ((0, vue_2.unref)(isNotFound))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("error_product_not_found", "Error, product not found!", "product_popup")) + " " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("sku", "SKU", "product_popup")) + ": ", 1),
                                    (0, vue_2.createElementVNode)("span", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)(productSku)), 1)
                                ]))
                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, [
                                    (0, vue_2.createElementVNode)("div", {
                                        class: (0, vue_2.normalizeClass)(["image lg:w-auto grid place-items-center", {
                                                'md:col-span-3 lg:col-span-3': (0, vue_2.unref)(product).type === 'tube' || (0, vue_2.unref)(product).type === 'tape',
                                                'md:col-span-3': (0, vue_2.unref)(product).type !== 'tube' && (0, vue_2.unref)(product).type !== 'tape',
                                            }])
                                    }, [
                                        (0, vue_2.createElementVNode)("img", {
                                            class: (0, vue_2.normalizeClass)(["md:max-h-[500px]", {
                                                    'max-h-[50vh]': (0, vue_2.unref)(product).type !== 'tube' && (0, vue_2.unref)(product).type !== 'tape',
                                                }]),
                                            src: (0, vue_2.unref)(product).image,
                                            alt: "product image"
                                        }, null, 10, _hoisted_5)
                                    ], 2),
                                    (0, vue_2.createElementVNode)("div", {
                                        class: (0, vue_2.normalizeClass)(["properties md:col-span-2 flex flex-col gap-8", {
                                                'lg:col-start-2': (0, vue_2.unref)(product).type === 'tube' || (0, vue_2.unref)(product).type === 'tape',
                                            }])
                                    }, [
                                        (0, vue_2.createElementVNode)("ul", _hoisted_6, [
                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(displayProperties((0, vue_2.unref)(product).type), (value, key) => {
                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: key }, [
                                                    (typeof (0, vue_2.unref)(product)[key] !== 'undefined' &&
                                                        String((0, vue_2.unref)(product)[key]) !== '' &&
                                                        Number((0, vue_2.unref)(product)[key]) !== 0)
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", _hoisted_7, [
                                                            (0, vue_2.createElementVNode)("span", _hoisted_8, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)(String(value).toLowerCase(), String(value), "product_popup")), 1),
                                                            (0, vue_2.createElementVNode)("span", _hoisted_9, (0, vue_2.toDisplayString)(getPropertyValue((0, vue_2.unref)(product).type, key, String((0, vue_2.unref)(product)[key]))), 1)
                                                        ]))
                                                        : (0, vue_2.createCommentVNode)("", true)
                                                ], 64));
                                            }), 128)),
                                            _hoisted_10
                                        ])
                                    ], 2),
                                    ('object' == typeof ((_a = (0, vue_2.unref)(product)) === null || _a === void 0 ? void 0 : _a.loadCapacityTable) &&
                                        Object.keys((0, vue_2.unref)(product).loadCapacityTable).length)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_11, [
                                            (0, vue_2.createElementVNode)("h2", _hoisted_12, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("load_capacity_table", "Load capacity table", "product_popup")), 1),
                                            (0, vue_2.createElementVNode)("div", _hoisted_13, [
                                                (0, vue_2.createElementVNode)("table", _hoisted_14, [
                                                    (0, vue_2.createElementVNode)("thead", null, [
                                                        (0, vue_2.createElementVNode)("tr", null, [
                                                            _hoisted_15,
                                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(Object.keys((0, vue_2.unref)(product).loadCapacityTable).sort(), (pressure) => {
                                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("th", { key: pressure }, [
                                                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(pressure) + " ", 1),
                                                                    (0, vue_2.createElementVNode)("span", _hoisted_16, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("bar", "bar", "product_popup")), 1)
                                                                ]));
                                                            }), 128))
                                                        ])
                                                    ]),
                                                    (0, vue_2.createElementVNode)("tbody", null, [
                                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(readSpeeds((0, vue_2.unref)(product).loadCapacityTable).sort(), (speed) => {
                                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", { key: speed }, [
                                                                (0, vue_2.createElementVNode)("th", null, [
                                                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(speed) + " ", 1),
                                                                    (0, vue_2.createElementVNode)("span", _hoisted_17, [
                                                                        (0, vue_2.createElementVNode)("sup", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("km", "km", "axapta_popup")), 1),
                                                                        (0, vue_2.createTextVNode)(" /"),
                                                                        (0, vue_2.createElementVNode)("sub", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("h", "h", "axapta_popup")), 1)
                                                                    ])
                                                                ]),
                                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(Object.keys((0, vue_2.unref)(product).loadCapacityTable).sort(), (pressure, key2) => {
                                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", { key: key2 }, (0, vue_2.toDisplayString)((0, vue_2.unref)(product).loadCapacityTable[pressure][speed]), 1));
                                                                }), 128))
                                                            ]));
                                                        }), 128))
                                                    ])
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_18, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("load_capacity_values_are_in_kilograms", "Load capacity values are in kilograms.", "product_popup")), 1)
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    ((0, vue_2.unref)(product).designDescription)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_19, [
                                            (0, vue_2.createElementVNode)("h2", _hoisted_20, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("about__DESIGN_NAME__design", "About {designName} design", "product_popup", { designName: (0, vue_2.unref)(product).designName })), 1),
                                            (0, vue_2.createElementVNode)("div", {
                                                innerHTML: (0, vue_2.unref)(product).designDescription
                                            }, null, 8, _hoisted_21)
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    ((0, vue_2.unref)(product).treadDescription)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_22, [
                                            (0, vue_2.createElementVNode)("h2", _hoisted_23, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("about__TREAD_NAME__tread", "About {treadName} tread", "product_popup", { treadName: (0, vue_2.unref)(product).treadName })), 1),
                                            (0, vue_2.createElementVNode)("div", {
                                                innerHTML: (0, vue_2.unref)(product).treadDescription
                                            }, null, 8, _hoisted_24)
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    ((0, vue_2.unref)(product).manufacturerDescription)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_25, [
                                            (0, vue_2.createElementVNode)("h2", _hoisted_26, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("about__MANUFACTURER_NAME__manufacturer", "About {manufacturerName} manufacturer", "product_popup", { manufacturerName: (0, vue_2.unref)(product).manufacturerName })), 1),
                                            (0, vue_2.createElementVNode)("div", {
                                                innerHTML: (0, vue_2.unref)(product).manufacturerDescription
                                            }, null, 8, _hoisted_27)
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ]))
                        ];
                    }),
                    _: 1
                }, 8, ["isOpen", "isLoading", "title"]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
